import type { SupabaseClient } from '@supabase/supabase-js'
import type { LoadAccessToken } from '@/modules/auth/use-cases'

export class SupabaseLoadAccessTokenRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: LoadAccessToken = async () => {
    const { data: { session } } = await this.client.auth.getSession()
    return session?.access_token ?? null
  }
}
